export function isWebSerialSupported(nav = navigator) {
  return typeof nav !== 'undefined' && !!nav.serial;
}

export function isMobile(nav = navigator) {
  const ua = (nav && nav.userAgent) || '';
  return /Android|iPhone|iPad|iPod|Mobile|Windows Phone/i.test(ua);
}

export function canFlash(nav = navigator) {
  return isWebSerialSupported(nav) && !isMobile(nav);
}
